import { MaterialReactTable } from "material-react-table";
import React, { useMemo, useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const DeviceDetails = ({ devices, setDevices, tableFor }) => {
  const [rowSelection, setRowSelection] = useState({});
  // handlers operate on `devices` state held in parent via setDevices
  const handleDeviceNameChange = (id, newName) => {
    setDevices(
      devices.map((device) =>
        device.id === id ? { ...device, CameraName: newName } : device,
      ),
    );
  };

  const handleCheckboxChange = (id, field) => {
    setDevices(
      devices.map((device) =>
        device.id === id
          ? { ...device, [field]: device[field] ? 0 : 1 }
          : device,
      ),
    );
  };

  // const handleLiveStreamTypeChange = (id, newValue) => {
  //   setDevices(
  //     devices.map((device) => {
  //       if (device.id !== id) return device;
  //       const rtsp = newValue === "Main"
  //         ? device.main_rtsp_uri
  //         : (Array.isArray(device.sub_rtsp_uri) ? device.sub_rtsp_uri[0] : "");
  //       return { ...device, LiveStreamType: newValue, RTSPURL: rtsp };
  //     }),
  //   );
  // };

  const handleLiveStreamTypeChange = (id, newValue) => {
    setDevices(
      devices.map((device) =>
        device.id === id ? { ...device, LiveStreamType: newValue } : device,
      ),
    );
  };

  const handlePlayBackStreamTypeChange = (id, newValue) => {
    setDevices(
      devices.map((device) =>
        device.id === id ? { ...device, PlayBackStreamType: newValue } : device,
      ),
    );
  };

  const handleDeviceStageChange = (id, newValue) => {
    setDevices(
      devices.map((device) =>
        device.id === id ? { ...device, DeviceStageId: newValue } : device,
      ),
    );
  };
  const handleSelectChange = (id) => {
    setDevices(
      devices.map((device) =>
        device.id === id
          ? { ...device, selected: device.selected === 1 ? 0 : 1 }
          : device,
      ),
    );
  };

  const handleServiceChange = (id, serviceField) => {
    setDevices(
      devices.map((device) =>
        device.id === id
          ? { ...device, [serviceField]: device[serviceField] ? 0 : 1 }
          : device,
      ),
    );
  };

  const getSelectionTitle = (device) => {
    if (device.onboarded) {
      return "Device already onboarded";
    }

    if (tableFor === 'camera') {
      return "Camera devices are auto-selected for onboarding. Please edit device details if needed.";
    }

    return "Select/Unselect device for onboarding";
  };


  const deviceColumns = useMemo(
    () => {
      const columns = [
        {
          accessorKey: "CameraName",
          header: "Camera Name",
          size: 200,
          Cell: ({ cell, row }) => (
            <input
              type="text"
              value={cell.getValue()}
              disabled={row.original.selected === 0 ? true : false}
              onChange={(e) =>
                handleDeviceNameChange(row.original.id, e.target.value)
              }
              className="DeviceCameraNameText"
              style={{
                border: `${row.original.CameraName ? "1px solid #0b70d1" : "1px solid red"}`,
              }}
            />
          ),
        },
        {
          accessorKey: "channel",
          header: "Channel",
          size: 120,
        },
        {
          accessorKey: "LiveStreamType",
          header: "Live Stream Type",
          size: 230,
          Cell: ({ cell, row }) => (
            <select
              value={cell.getValue()}
              onChange={(e) =>
                handleLiveStreamTypeChange(row.original.id, e.target.value)
              }
              style={{
                border: "1px solid #0b70d1",
                padding: "4px 6px",
                borderRadius: "3px",
                width: "95%",
                backgroundPosition: "calc(100% - 15px) 10px, calc(100% - 13px) 12px, 99% 0",
              }}
              disabled={row.original.selected === 0 ? true : false}
            >
              <option value="Main">Main</option>
              <option value="Sub">Sub</option>
            </select>
          ),
        },
        {
          accessorKey: "PlayBackStreamType",
          header: "Playback Stream Type",
          size: 260,
          Cell: ({ cell, row }) => (
            <select
              value={cell.getValue()}
              onChange={(e) =>
                handlePlayBackStreamTypeChange(row.original.id, e.target.value)
              }
              style={{
                border: "1px solid #0b70d1",
                padding: "4px 6px",
                borderRadius: "3px",
                width: "95%",
                backgroundPosition: "calc(100% - 15px) 10px, calc(100% - 13px) 12px, 99% 0",
              }}
              disabled={row.original.selected === 0 ? true : false}
            >
              <option value="Main">Main</option>
              <option value="Sub">Sub</option>
            </select>
          ),
        },
        {
          accessorKey: "MainRTSPURL",
          header: "Main RTSP URL",
          size: 300,
          Cell: ({ cell }) => (
            <span style={{ wordBreak: "break-all", fontSize: "12px" }}>
              {cell.getValue()}
            </span>
          ),
        },
        {
          accessorKey: "mainStreamResolution",
          header: "Main Stream- Resolution,Encoding, FPS, Bitrate",
          size: 380,
          Cell: ({ row }) => (
            
           <div className="stream-card">
              <div className="stream-row">
                <span className="label">Resolution - </span>
                <span className="value">{row?.original?.main_resolution_width || "NA"} × {row?.original?.main_resolution_height || "NA"}</span>
              </div>             

               <div className="stream-row">
                <span className="label">Encoding - </span>
                <span className="value">{row?.original?.main_encoding || "NA"}</span>
              </div>

              <div className="stream-row">
                <span className="label">FPS - </span>
                <span className="value">{row?.original?.main_fps || "NA"}</span>
              </div>

              <div className="stream-row">
                <span className="label">Bitrate - </span>
                <span className="value">{row?.original?.main_bitrate || "NA"}</span>
              </div>
            </div>
          ),
        },
        {
          accessorKey: "SubRTSPURL",
          header: "Sub RTSP URL",
          size: 300,
          Cell: ({ cell }) => (
            <span style={{ wordBreak: "break-all", fontSize: "12px" }}>
              {cell.getValue()}
            </span>
          ),
        },
       
        {
          accessorKey: "subStreamResolution",
          header: "Sub Stream- Resolution, Encoding, FPS, Bitrate",
          size: 380,
          Cell: ({ row }) => (
            <div className="stream-card">
              <div className="stream-row">
                <span className="label">Resolution - </span>
                <span className="value">{row?.original?.sub_resolution_width || "NA"} × {row?.original?.sub_resolution_height || "NA"}</span>
              </div>             

               <div className="stream-row">
                <span className="label">Encoding - </span>
                <span className="value">{row?.original?.sub_encoding || "NA"}</span>
              </div>

              <div className="stream-row">
                <span className="label">FPS - </span>
                <span className="value">{row?.original?.sub_fps || "NA"}</span>
              </div>

              <div className="stream-row">
                <span className="label">Bitrate - </span>
                <span className="value">{row?.original?.sub_bitrate || "NA"}</span>
              </div>
            </div>
          ),
        },
        // {
        //   accessorKey: "IsTranscodingEnabled",
        //   header: "Transcoding",
        //   size: 180,
        //   Cell: ({ row }) => (
        //     <input
        //       type="checkbox"
        //       checked={row.original.IsTranscodingEnabled ? true : false}
        //       onChange={() =>
        //         handleCheckboxChange(row.original.id, "IsTranscodingEnabled")
        //       }
        //       disabled={row.original.selected === 0 ? true : false}
        //     />
        //   ),
        // },
        // {
        //   accessorKey: "IsPlayBackTranscodingEnabled",
        //   header: "Playback Transcoding",
        //   size: 220,
        //   Cell: ({ row }) => (
        //     <input
        //       type="checkbox"
        //       checked={row.original.IsPlayBackTranscodingEnabled ? true : false}
        //       onChange={() =>
        //         handleCheckboxChange(
        //           row.original.id,
        //           "IsPlayBackTranscodingEnabled",
        //         )
        //       }
        //       disabled={row.original.selected === 0 ? true : false}
        //     />
        //   ),
        // },
        {
          accessorKey: "IsPtz",
          header: "PTZ",
          size: 100,
          Cell: ({ row }) => (
            // <input
            //   type="checkbox"
            //   checked={row.original.IsPtz ? true : false}
            //   onChange={() => handleCheckboxChange(row.original.id, "IsPtz")}
            //   disabled={row.original.selected === 0 ? true : false}
            // />
            <>
            {row.original.IsPtz ? <CheckCircleIcon sx={{ color: "#2e7d32", mr: 0.5 }} /> : <CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />}
             </>
          ),
        },
        {
          accessorKey: "IsTwoWayEnabled",
          header: "Two Way",
          size: 150,
          Cell: ({ row }) => (
            // <input
            //   type="checkbox"
            //   checked={row.original.IsTwoWayEnabled ? true : false}
            //   onChange={() =>
            //     handleCheckboxChange(row.original.id, "IsTwoWayEnabled")
            //   }
            //   disabled={row.original.selected === 0 ? true : false}
            // />
            <>
            {row.original.IsTwoWayEnabled ? <CheckCircleIcon sx={{ color: "#2e7d32", mr: 0.5 }} /> : <CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />}
             </>
          ),
        },
        // {
        //   accessorKey: "ISPlaybackUTC",
        //   header: "Playback UTC",
        //   size: 200,
        //   Cell: ({ row }) => (
        //     <input
        //       type="checkbox"
        //       checked={row.original.ISPlaybackUTC ? true : false}
        //       onChange={() =>
        //         handleCheckboxChange(row.original.id, "ISPlaybackUTC")
        //       }
        //       disabled={row.original.selected === 0 ? true : false}
        //     />
        //   ),
        // },
        {
          accessorKey: "DeviceStageId",
          header: "Device Stage",
          size: 170,
          Cell: ({ cell, row }) => (
            <>
            <span>Live</span>

            {/* // <select
            //   value={cell.getValue()}
            //   onChange={(e) =>
            //     handleDeviceStageChange(row.original.id, e.target.value)
            //   }
            //   style={{
            //     border: "1px solid #ccc",
            //     padding: "4px 6px",
            //     borderRadius: "3px",
            //     width: "95%",
            //     background: "transparent",
            //   }}
            //   disabled={row.original.selected === 0 ? true : false}
            // >
            //   <option value="Live">Live</option>
            //   <option value="QC Pending">QC Pending</option>
            // </select> */}
            </>
          ),
        },
        {
          accessorKey: "licenseServices",
          header: "License Services",
          size: 400,
          Cell: ({ row }) => (
            <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  checked={row.original.MonitoringService ? true : false}
                  onChange={() =>
                    handleServiceChange(row.original.id, "MonitoringService")
                  }
                  disabled={row.original.selected === 0 ? true : false}
                />
                <span style={{ fontSize: "13px" }}>CCTV</span>
              </label>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  checked={row.original.AlertService ? true : false}
                  onChange={() =>
                    handleServiceChange(row.original.id, "AlertService")
                  }
                  disabled={row.original.selected === 0 ? true : false}
                />
                <span style={{ fontSize: "13px" }}>Alerts</span>
              </label>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  checked={row.original.HMService ? true : false}
                  onChange={() =>
                    handleServiceChange(row.original.id, "HMService")
                  }
                  disabled={row.original.selected === 0 ? true : false}
                />
                <span style={{ fontSize: "13px" }}>Health Monitoring</span>
              </label>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  checked={row.original.RecordingBackupService ? true : false}
                  onChange={() =>
                    handleServiceChange(row.original.id, "RecordingBackupService")
                  }
                  disabled={row.original.selected === 0 ? true : false}
                />
                <span style={{ fontSize: "13px" }}>Video Backup</span>
              </label>
            </div>
          ),
        },
      ];
      //if (tableFor !== 'camera') {
        columns.unshift({
          accessorKey: "selected",
          header: "Select",
          size: 100,
          Cell: ({ row }) => (
            <input
              type="checkbox"
              title={getSelectionTitle(row.original)}
              disabled = {row.original.onboarded}
              checked={row.original.selected === 1}
              onChange={() => {
                if(tableFor === 'camera'){
                  return;
                }
                handleSelectChange(row.original.id)
              }}
            />
          ),
        });
      //}
      return columns;
    },
    [devices, tableFor],
  );
  //   const getSelectedDevices = () => {
  //   const selectedIds = Object.keys(rowSelection);

  //   const selectedDevices = devices.filter((device, index) =>
  //     selectedIds.includes(index.toString())
  //   );

  //   console.log(selectedDevices);
  // };

  return (
    <MaterialReactTable
      columns={deviceColumns}
      data={devices}
      //enableRowSelection
      enableSelectAll={tableFor !== 'camera'}
      onRowSelectionChange={setRowSelection}
      state={{ rowSelection }}
      enableStickyHeader
      enableColumnResizing
      columnResizeMode="onEnd"
      enableColumnOrdering={false}
      enablePagination={false}
      muiTableContainerProps={{
        sx: {
          maxHeight: "600px",
          overflowY: "auto",
          minWidth: "1000px"
        },
      }}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "#f5f5f5",
          fontWeight: "600",
          padding: "8px",
          '& .Mui-TableHeadCell-Content': {
            color: 'black',
          },
          '& .MuiTypography-root': {
            color: 'black',
          },
        },
      }}
      muiTableBodyCellProps={{
        sx: {
          padding: "8px",
        },
      }}
    />
  );
};

export default DeviceDetails;
